module.exports = __webpack_public_path__ + "img/background.ca583863.webp";